import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { Combobox } from '@headlessui/react';
import { DocumentCheckIcon } from '@heroicons/react/24/outline';

type WorkpaperOptionProps = {
    noGroups?: boolean;
    workpaper: { id: string; name: string; entity: { id: string; name: string } };
    isLastItem: boolean;
    onNavigate: () => void;
};

function WorkpaperOption({ noGroups, workpaper, isLastItem, onNavigate }: WorkpaperOptionProps): JSX.Element {
    const { shortId } = useFirmContext();
    const redirectUrl = `/${shortId}/workpapers/${workpaper.id}/dashboard`;

    return (
        <Link
            key={workpaper.id}
            to={redirectUrl}
            onMouseDown={(e): void => {
                e.preventDefault();
                e.stopPropagation();
            }}
            onClick={onNavigate}
        >
            <Combobox.Option
                key={workpaper.id}
                value={redirectUrl}
                className={({ active }): string =>
                    `flex items-center gap-2 text-gray-500 text-sm pr-4 py-2 ${noGroups ? 'pl-10' : 'pl-16'} ${
                        !isLastItem && 'border-b border-gray-200 dark:border-white/[0.07]'
                    } ${active && 'bg-indigo-600 text-white dark:bg-white/[0.05]'}`
                }
            >
                <DocumentCheckIcon className="w-4 h-4" />
                {workpaper.name}
            </Combobox.Option>
        </Link>
    );
}

export default WorkpaperOption;
